export const prioritizeNudgeTextBold = "gmMbB";
export const prioritizeNudgeTextDescription = "hIPSEc";
export const prioritizeNudgeTextDescriptionOnDelivery = "CFZiKc";
export const dontShowAgainMenuText = "QET_Cb";
export const customizeInstructionsMenuText = "AxOlLd";
export default {prioritizeNudgeTextBold,prioritizeNudgeTextDescription,prioritizeNudgeTextDescriptionOnDelivery,dontShowAgainMenuText,customizeInstructionsMenuText};